export default __webpack_public_path__ + "static/media/Image_5.e1080278.png";